import { IController, IComponentOptions } from "angular";

import { IDropdownActionsMenuOptions } from "../models";

export class DropdownActionsMenuCtrl implements IController {
  options: IDropdownActionsMenuOptions;
  onToggle: (args: unknown) => unknown;

  $onInit(): void {
    if (!this.options) {
      this.options = { iconName: "menu", size: "large" };
    }

    if (!this.options.iconName) {
      this.options.iconName = "menu";
    }

    if (!this.options.size) {
      this.options.size = "large";
    }
  }
}

export const DropdownActionsMenuComponent: IComponentOptions = {
  controller: DropdownActionsMenuCtrl,
  templateUrl: require("./dropdown-actions-menu.jade"),
  transclude: true,
  bindings: {
    options: "<",
    onToggle: "&",
  },
};
